import { useQuery } from "@tanstack/react-query";
import { getAgentDownloadLink, getLatestEnterpriseApp } from "controller/api";

export const useGetDownloadLink = ({
  type,
  platform,
  mspId,
  enabled = true,
}: {
  type: string;
  platform: string;
  mspId: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ["agent-download-link", type, platform, mspId],
    queryFn: () => getAgentDownloadLink({ type, platform, mspId }),
    enabled: enabled && !!mspId,
    staleTime: Infinity,
  });
};

export const useGetLatestEnterpriseApp = ({
  mspId,
  enabled,
}: {
  mspId: string;
  enabled: boolean;
}) => {
  return useQuery({
    queryKey: ["enterprise-app", mspId || ""],
    queryFn: () => getLatestEnterpriseApp(mspId || ""),
    enabled: enabled,
    staleTime: Infinity,
  });
};
